// extracted by mini-css-extract-plugin
module.exports = {"title":"H1_title__2XzF9"};